export default "__VITE_ASSET__CzRQTlBs__"